import { createTrigger } from 'src/utils/createTrigger';

export const LOADER_SHOW = createTrigger<void, string>('LOADER_SHOW');
export const LOADER_HIDE = createTrigger<void, string>('LOADER_HIDE');
